/**
 * Dashboard – në vend të data logger/inverter/energy meter përdoret pajisja S475.
 * Ruhet kompani, users, navigimi i plotë SCADA.
 */
import DashboardS475 from './DashboardS475';
export default DashboardS475;
